import React, { useEffect, Fragment, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import {
  GetGroupAccountById,
  UpdateGroupAccount
} from "../../../api/masters/groupAccountAPI";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  underGroup: yup.string().required("Under Group is required"),
  nature: yup.string().optional()
});

const EditGroupAccount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchData = async () => {
    try {
      const response = await GetGroupAccountById(id); // Make sure login function returns token

      if (response.success) {
        setValue("name", response.data.name);
        setValue("underGroup", response.data.underGroup);
        setValue("nature", response.data.nature);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      const loadData = async () => {
        try {
          dispatch({ type: "LOADER_START" });

          await fetchData();
        } catch (error) {
          showToast("error", error);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      };

      loadData();
    },
    [id]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateGroupAccount(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return <Fragment>
      <Breadcrumb parent="Group Account" title="Edit Group Account" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <h5>Edit Group Account</h5>
                  <Link to={`/masters/group-account/list`}>
                    <button className="btn btn-primary" id="list">
                      List Group Account
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Group Account
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form ref={formRef} className="form theme-form" onSubmit={handleSubmit(onSubmit)}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Name *</label>
                        <input className="form-control" id="name" type="text" placeholder="Name" {...register("name")} />
                        {errors.name && <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Under Group *</label>
                        <input className="form-control" id="name" type="text" placeholder="Under Group" {...register("underGroup")} />
                        {errors.underGroup && <p className="text-danger">
                            {errors.underGroup.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="nature">Nature</label>
                        <select className="form-control" id="nature" type="text" placeholder="Nature" {...register("nature")}>
                          <option value="">Select Nature</option>
                          <option value="Bank">Bank</option>
                          <option value="Cash">Cash</option>
                          <option value="Customer">Customer</option>
                          <option value="Others">Others</option>
                          <option value="Purchase">Purchase</option>
                          <option value="Revenue">Revenue</option>
                          <option value="Sale">Sale</option>
                          <option value="Supplier">Supplier</option>
                          <option value="Unsecured Loan">
                            Unsecured Loan
                          </option>
                          <option value="Expenditure">Expenditure</option>
                          <option value="Asset">Asset</option>
                        </select>
                        {errors.nature && <p className="text-danger">
                            {errors.nature.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>;
};

export default EditGroupAccount;
